import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as Sentry from '@sentry/react';

import './i18n';
import './styles/app.scss';

Sentry.init({
    dsn: 'https://2e89c52d958686d25b108b11e3a1546b@o429115.ingest.us.sentry.io/4509530905116675',
    tracesSampleRate: 0.5,
    sendDefaultPii: true,
});

const root = createRoot(document.getElementById('root')!);
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <Sentry.ErrorBoundary fallback={<div>Помилка</div>}>
                <App />
            </Sentry.ErrorBoundary>
        </BrowserRouter>
    </React.StrictMode>
);
